import { render, staticRenderFns } from "./SolarTab.vue?vue&type=template&id=241a77d5&"
import script from "./SolarTab.vue?vue&type=script&lang=js&"
export * from "./SolarTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports